import React, { useCallback } from "react";
import styles from "./deductions.module.scss";
import { cn } from "utils";
import Input from "components/Input";
import Select from "components/Select";
import SubmitButton from "components/SubmitButton";
import { options } from "constants/options";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { MCNDeductionInputs, mcnDeductionSchema } from "./const";

const AddEditMcnBenefit = () => {
    const {
        register,
        handleSubmit,
        formState: { errors }
    } = useForm({
        resolver: yupResolver(mcnDeductionSchema)
    });

    const onSubmit = useCallback((values) => {
        console.log({ values });
    }, [])

    return (
        <form
            className={cn("container-spacing pt-3 pb-5")}
            onSubmit={handleSubmit(onSubmit)}
        >
            <h3 className={cn("title mt-2")}>Add Deduction</h3>
            <div>
                <div>
                    <div className={cn("container-fluid padding-0")}>
                        <div className={cn("row")}>
                            <div className="col-lg-8 col-12">
                                <Select
                                    label="Assigned Employee"
                                    fullWidth
                                    variant="flat"
                                    options={[]}
                                    {...register(MCNDeductionInputs.ASSIGNED_EMPLOYEE)}
                                    error={!!errors[MCNDeductionInputs.ASSIGNED_EMPLOYEE]}
                                    errorText={errors[MCNDeductionInputs.ASSIGNED_EMPLOYEE]?.message}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <p className={cn("info-title mt-3")}>General Information</p>
                    <div className={cn("container-fluid padding-0")}>
                        <div className={cn("row")}>
                            <div className="col-lg-8 col-12">
                                <Input
                                    label="Description*"
                                    fullWidth
                                    variant="flat"
                                    {...register(MCNDeductionInputs.DESCRIPTION)}
                                    error={!!errors[MCNDeductionInputs.DESCRIPTION]}
                                    errorText={errors[MCNDeductionInputs.DESCRIPTION]?.message}
                                />
                            </div>
                        </div>
                        <div className={cn("row g-3 mt-2")}>
                            <div className="col-lg-4 col-12">
                                <Input
                                    label="Start Date"
                                    fullWidth
                                    variant="flat"
                                    type="date"
                                    {...register(MCNDeductionInputs.START_DATE)}
                                    error={!!errors[MCNDeductionInputs.START_DATE]}
                                    errorText={errors[MCNDeductionInputs.START_DATE]?.message}
                                />
                            </div>
                            <div className="col-lg-4 col-12">
                                <Input
                                    label="End Date"
                                    fullWidth
                                    variant="flat"
                                    type="date"
                                    {...register(MCNDeductionInputs.END_DATE)}
                                    error={!!errors[MCNDeductionInputs.END_DATE]}
                                    errorText={errors[MCNDeductionInputs.END_DATE]?.message}
                                />
                            </div>
                        </div>
                        <div className={cn("row g-3 mt-2")}>
                            <div className="col-lg-4 col-12">
                                <Input
                                    label="Deduction Amount*"
                                    fullWidth
                                    variant="flat"
                                    {...register(MCNDeductionInputs.DEDUCTION_AMOUNT)}
                                    error={!!errors[MCNDeductionInputs.DEDUCTION_AMOUNT]}
                                    errorText={errors[MCNDeductionInputs.DEDUCTION_AMOUNT]?.message}
                                />
                            </div>
                            <div className="col-lg-4 col-12">
                                <Input
                                    label="Deduction Gap*"
                                    fullWidth
                                    variant="flat"
                                    {...register(MCNDeductionInputs.DEDUCTION_GAP)}
                                    error={!!errors[MCNDeductionInputs.DEDUCTION_GAP]}
                                    errorText={errors[MCNDeductionInputs.DEDUCTION_GAP]?.message}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mt-5">
                    <SubmitButton
                        submitText="Add Deduction"
                    />
                </div>
            </div>
        </form>
    )
}

export default AddEditMcnBenefit;